
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CaseStudyService } from './case-study.service';
import { ConsumptionHist } from '../Models/MeterModel';

@Injectable({
  providedIn: 'root'
})
export class HistNotSummerResolverService implements Resolve<Array<ConsumptionHist>> {
  HistData: Observable<Array<ConsumptionHist>>;
  constructor(private casestudySvc: CaseStudyService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<ConsumptionHist>> | Promise<Array<ConsumptionHist>> | Array<ConsumptionHist> {

    this.HistData = this.casestudySvc.getHistData("6-9False");
    return this.HistData;
  }
}
